// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.shared

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.shared.CredentialIssuerSettingsAndroidKeySettings
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItem
import org.multipaz.crypto.Algorithm

fun CredentialIssuerSettingsAndroidKeySettings.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "tIRMjJGp6VcAoDaQ6TrMQV47oQmfz4DNwfvodNvOC9Q")
val CredentialIssuerSettingsAndroidKeySettings_cborSchemaId = ByteString(-76, -124, 76, -116, -111, -87, -23, 87, 0, -96, 54, -112, -23, 58, -52, 65, 94, 59, -95, 9, -97, -49, -128, -51, -63, -5, -24, 116, -37, -50, 11, -44)

fun CredentialIssuerSettingsAndroidKeySettings.Companion.fromCbor(data: ByteArray): CredentialIssuerSettingsAndroidKeySettings {
    return CredentialIssuerSettingsAndroidKeySettings.fromDataItem(Cbor.decode(data))
}

val CredentialIssuerSettingsAndroidKeySettings.Companion.cborSchemaId: ByteString
    get() = CredentialIssuerSettingsAndroidKeySettings_cborSchemaId

fun CredentialIssuerSettingsAndroidKeySettings.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("algorithm", Tstr(this.algorithm.name))
    builder.put("useStrongBox", this.useStrongBox.toDataItem())
    builder.put("userAuthenticationTimeoutMillis", this.userAuthenticationTimeoutMillis.toDataItem())
    builder.put("userAuthenticationLskf", this.userAuthenticationLskf.toDataItem())
    builder.put("userAuthenticationBiometric", this.userAuthenticationBiometric.toDataItem())
    return builder.end().build()
}

fun CredentialIssuerSettingsAndroidKeySettings.Companion.fromDataItem(dataItem: DataItem): CredentialIssuerSettingsAndroidKeySettings {
    val algorithm = Algorithm.valueOf(dataItem["algorithm"].asTstr)
    val useStrongBox = dataItem["useStrongBox"].asBoolean
    val userAuthenticationTimeoutMillis = dataItem["userAuthenticationTimeoutMillis"].asNumber
    val userAuthenticationLskf = dataItem["userAuthenticationLskf"].asBoolean
    val userAuthenticationBiometric = dataItem["userAuthenticationBiometric"].asBoolean
    return CredentialIssuerSettingsAndroidKeySettings(
        algorithm = algorithm,
        useStrongBox = useStrongBox,
        userAuthenticationTimeoutMillis = userAuthenticationTimeoutMillis,
        userAuthenticationLskf = userAuthenticationLskf,
        userAuthenticationBiometric = userAuthenticationBiometric,
    )
}
